<template>
    <div>
     <v-snackbar bottom  dark color="green darken-2"  v-model="snackbar.show">
        {{ snackbar.message }}
    </v-snackbar>
    <loading :active.sync="isLoading"  :is-full-page="fullPage"></loading>
       
      

       <v-container>
      <v-row>
        <v-col cols="12" sm="6" md="3">
          <b-form-input v-model="customer.customerName" size="sm" placeholder="Name*" autofocus ></b-form-input>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <b-form-input v-model="customer.mobile" type="number" size="sm" placeholder="Mobile No*" focus minlength="10" maxlength="12"></b-form-input>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <b-form-input v-model="customer.phone" type="number" size="sm" placeholder="Phone No" focus minlength="10" maxlength="12"></b-form-input>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <b-form-input v-model="customer.email" type="email" size="sm" placeholder="Email Id" focus></b-form-input>
        </v-col>
         <v-col cols="12" sm="6" md="3" hidden>
          <b-form-input v-model="customer.cid" type="text" size="sm" placeholder="Email Id" focus></b-form-input>
        </v-col>

        <v-col cols="12" sm="6" md="3">
    <b-form-textarea
    size="sm" 
      id="textarea"
      v-model="customer.houseNo"
      placeholder="House No.,Building name*"
      rows="3"
      max-rows="6"
    ></b-form-textarea>

   </v-col>
    <v-col cols="12" sm="6" md="3">
          <b-form-input v-model="customer.area" size="sm" placeholder="Landmark*"  ></b-form-input>
        </v-col>
         <v-col cols="6" sm="6" md="3">
          <b-form-input v-model="customer.city" type="text" size="sm" placeholder="City/District/Town*" class="input" focus></b-form-input>
        </v-col>
        <v-col cols="6" sm="6" md="3">
          <b-form-input v-model="customer.state" type="text" size="sm" placeholder="State*" class="input" focus></b-form-input>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <b-form-input v-model="customer.piNcode" type="number" size="sm" placeholder="Pincode*" focus></b-form-input>
        </v-col>
          <v-col cols="12" sm="6" md="3"  style="    text-align: left;">
         <b-form-group label="Address Type :" class="radio">
      <b-form-radio v-model="customer.addressType" name="some-radios" value="Home">Home (All day delivery)</b-form-radio>
      <b-form-radio v-model="customer.addressType" name="some-radios" value="Work">Work (Delivery between 10 AM-5 PM)</b-form-radio>
    </b-form-group >
    <v-col cols="12" sm="6" md="3" style="margin-bottom:2em;">
          <b-button variant="danger" size="sm" @click="backto">Cancel</b-button>&nbsp;
          <b-button  variant="success" size="sm" @click="updateaddress">Update</b-button>
        </v-col>
       </v-col>

        
      </v-row>
        </v-container>
    </div>
</template>
<script>
import Vue from 'vue'
 import axios from 'axios';
import Router from '../router';
 import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
     components: {      
        Loading
     },
    
     data: () => ({
        editdataarr :'',
        isLoading: false,
        fullPage: true,
        customer:{
          
          customerName:'',
          mobile:'',
          phone:'',
          email:'',
          houseNo:'',
          area:'',
          piNcode:'',
          city:'',
          state:'',
          addressType:'',
          createdDate:'',
          remarks:'',
          geoLocation:''
         

      },
      snackbar: {
                show: false,
                message: null,
                color: null
            },
      alladdress:[],
      pos:''
            
            
      }),
      mounted(){
           //set values
           this.editdataarr = JSON.parse(localStorage.getItem("editableaddress"))
           this.alladdress = JSON.parse(localStorage.getItem("Address"))
           this.pos = JSON.parse(localStorage.getItem("editpos"))
           //get current datetime
            const today = new Date();
                    const date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
                    const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
                    const dateTime = date +' '+ time;
                    this.customer.createdDate = dateTime;

           //bind data
           this.customer.customerName = this.editdataarr.customerName
           this.customer.mobile = this.editdataarr.mobile
           this.customer.phone = this.editdataarr.phone
           this.customer.email = this.editdataarr.email
           this.customer.houseNo = this.editdataarr.houseNo
           this.customer.area = this.editdataarr.area
           this.customer.piNcode = this.editdataarr.piNcode
           this.customer.city = this.editdataarr.city
           this.customer.state = this.editdataarr.state
           this.customer.addressType = this.editdataarr.addressType
           this.customer.remarks = this.editdataarr.remarks
           this.customer.cid = this.editdataarr.cid
          
      },
        methods:{
          backto(){
               Router.push('/customer');
          },
          updateaddress(){
              this.alladdress[this.pos] = this.customer
              localStorage.setItem("Address",JSON.stringify(this.alladdress))
              this.snackbar = {
                        message: "Updated Successfully...",
                        color: 'success',
                        show: true
                    }
                    setTimeout(() => {
                        Router.push('/customer');
                    }, 2000);
            //   console.log(JSON.stringify(this.customer))
          }
        },
      
      
}
</script>
<style scoped>

</style>